import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss']
})
export class ToggleButtonComponent {
  @Input() checked: boolean = false;
  @Input() id: string = '';
  @Output() onChange = new EventEmitter<boolean>();
  @Input() props: Partial<Omit<HTMLInputElement, 'checked' | 'type' | 'id' | 'onchange'>> = {};

  onToggleChange(event: any) {
    this.onChange.emit(event.target.checked);
  }
}
